import { IGetControlePatrimonioControleByIdUseCase } from "../../../presentation/useCases/read/get_controle_patrimonio_controle_by_id_use_case";
import {
  GetControlePatrimonioControleByIdRequestModel,
  GetControlePatrimonioControleByIdResponseModel,
} from "../../models/ControledePatrimonioControleModel";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetControlePatrimonioControleByIdUseCase
 */

export class GetControlePatrimonioControleByIdUseCase implements IGetControlePatrimonioControleByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {}

  async getControlePatrimonioControleById(
    model: GetControlePatrimonioControleByIdRequestModel,
  ): Promise<GetControlePatrimonioControleByIdResponseModel> {
    return await this.repository.getControlePatrimonioControleById(model);
  }
}
